import _ from "lodash";
import moment from "moment";
import { BaseDatePicker } from "src/components";
import BaseSection from "src/components/layout/BaseSection";
import { YmdFormat } from "src/utils";

type Props = {
  saveData: any;
  setSaveData: any;
};

const ServiceType = ({ saveData, setSaveData }: Props) => {
  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <h2>신청 시간</h2>
      </div>

      <div className="flex-center">
        <BaseSection
          title="신청 시작 시간"
          required={true}
          children={
            <div className="minmax160">
              <BaseDatePicker
                type="full"
                name={"useStartTime"}
                timeIntervals={30}
                selectedDate={saveData.useStartTime ? moment(saveData.useStartTime).toDate() : null}
                setDate={(date: string) => {
                  const temp = _.cloneDeep(saveData);
                  temp.useStartTime = moment(date).format(YmdFormat.WITH_TIME_ZONE);
                  temp.useEndTime = moment(temp.useStartTime).add("minute", 30).format(YmdFormat.WITH_TIME_ZONE);

                  setSaveData(temp);
                }}
                disabled={saveData.selectedFacility === undefined}
              />
            </div>
          }
        />
        <BaseSection
          title="신청 종료 시간"
          required={true}
          children={
            <div className="minmax160">
              <BaseDatePicker
                type="full"
                name={"useEndTime"}
                timeIntervals={30}
                filteredTime={saveData.useStartTime}
                useFilterdTime={true}
                minDate={moment(saveData.useStartTime).toDate()}
                {...(saveData.useStartTime
                  ? {
                      minTime: moment(saveData.useEndTime).isSame(moment(saveData.useStartTime), "day")
                        ? moment(saveData.useStartTime).add(30, "minutes").toDate()
                        : moment().startOf("day").toDate(),
                      maxTime: moment().endOf("day").toDate(),
                    }
                  : {})}
                selectedDate={saveData.useEndTime ? moment(saveData.useEndTime).toDate() : null}
                setDate={(date: string) => {
                  const temp = _.cloneDeep(saveData);
                  temp.useEndTime = moment(date).format(YmdFormat.WITH_TIME_ZONE);
                  setSaveData(temp);
                }}
                disabled={saveData.selectedFacility === undefined}
              />
            </div>
          }
        />
      </div>
    </article>
  );
};

export default ServiceType;
